module.exports = __webpack_public_path__ + "media/B16.dd44e264.mp3";